import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { History, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const REASONS = { export: "Bij export", "voor upload": "Vlak voor upload", "voor herstel": "Vlak voor herstel" };

export const Snapshots = ({ open, onOpenChange, profile, onDone }) => {
  const [list, setList] = useState([]);
  useEffect(() => {
    if (!open) return;
    axios.get(`${API}/leads/snapshots`, { params: { profile } }).then(({ data }) => setList(data)).catch(() => setList([]));
  }, [open, profile]);

  const restore = async (s, mode) => {
    const when = new Date(s.created_at).toLocaleString("nl-NL");
    const msg = mode === "contact"
      ? `Alleen contactgegevens terugzetten naar ${when}?\n\nNaam, e-mail, telefoon, adres, website en contactpersoon worden teruggezet; verwijderde leads komen terug. Verzonden mails, reacties en klanten blijven zoals ze nu zijn.`
      : `ALLES terugzetten naar ${when} (${s.count} leads)?\n\nLet op: ook CRM-wijzigingen sinds dat moment (verzonden, reacties, klanten) worden teruggezet.`;
    if (!window.confirm(`${msg}\n\nDe huidige stand wordt eerst als herstelpunt bewaard.`)) return;
    try {
      const { data } = await axios.post(`${API}/leads/snapshots/${s.id}/restore`, null, { params: { mode } });
      toast.success(mode === "contact" ? `Contactgegevens van ${data.restored} lead(s) hersteld` : `${data.restored} leads hersteld naar ${when}`);
      onOpenChange(false); onDone?.();
    } catch { toast.error("Herstellen mislukt"); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="snapshots-dialog" className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2"><History className="w-5 h-5 text-[#FF4500]" /> Herstelpunten</DialogTitle>
          <DialogDescription>Automatisch bewaard bij elke export en vlak voor elke upload. De laatste 10 per profiel blijven bewaard.</DialogDescription>
        </DialogHeader>
        {list.length === 0 ? (
          <p className="text-sm text-slate-500">Nog geen herstelpunten. Er wordt er een gemaakt bij je volgende export.</p>
        ) : (
          <ul className="divide-y divide-slate-100">
            {list.map((s, i) => (
              <li key={s.id} data-testid={`snapshot-row-${i}`} className="flex items-center gap-3 py-2.5">
                <div className="flex-1">
                  <div className="text-sm font-medium">{new Date(s.created_at).toLocaleString("nl-NL")}</div>
                  <div className="text-xs text-slate-500">{REASONS[s.reason] || s.reason} · {s.count} leads</div>
                </div>
                <Button data-testid={`snapshot-restore-contact-${i}`} size="sm" onClick={() => restore(s, "contact")} className="rounded-full bg-slate-900 hover:bg-slate-700 text-white">
                  <RotateCcw className="w-3.5 h-3.5 mr-1.5" /> Alleen contactgegevens
                </Button>
                <Button data-testid={`snapshot-restore-${i}`} size="sm" variant="outline" onClick={() => restore(s, "all")} className="rounded-full">
                  Herstel alles
                </Button>
              </li>
            ))}
          </ul>
        )}
      </DialogContent>
    </Dialog>
  );
};
